import Input from 'antd/es/input';

export default Input;
